/**
 * @author qiumaoyun
 * 新增、查看、编辑工作流
 */
import Component from '../../../lib/component';
import template from './add-workflow.html';
import '../approval-workflow/approval-workflow.scss';
import './add-workflow.scss';
import '../../../assets/scss/workflow/workflow-base.scss'
import Mediator from '../../../lib/mediator';
import WorkFlow from '../workflow-drawflow/workflow';
import {workflowService} from '../../../services/workflow/workflow.service';
import {FormService} from "../../../services/formService/formService"
import msgBox from '../../../lib/msgbox';
import {PMAPI,PMENUM} from '../../../lib/postmsg';
import SettingPrint from '../../form/setting-print/setting-print'
import FormEntrys from "../../../entrys/form";
import {CreateFormServer} from '../../../services/formService/CreateFormServer';

// import '../../../lib/Adaptation'
// import '../../../lib/Adaptation_content'

let config={
    template: template,
    data:{
        obj: {},
        is_view: 0,
        action: 0,
        cache_old: {},
        focusArr: [],
        noRequestFormData:[],
        user: [],
        nameArr: [], //关注人姓名
        idArr: [], //关注人id
        htmlStr: [], // 关注人添加的html代码
        allUsersInfo: {},
        focusUsersId: [],
        focusUsers: {},
        //附件状态
        attachmentState:{}
    },
    actions:{
        openAddFollower() {
            PMAPI.openDialogByIframe(`/iframe/addfocus/`, {
                width: 800,
                height: 620,
                title: `添加关注人`,
                modal: true
            },{
                users:this.data.user
            }).then(res => {
                if (!res.onlyclose) {
                    let nameArr = [],
                        idArr = [],
                        htmlStr = [];
                    for (let k in res) {
                        nameArr.push(res[k]);
                        htmlStr.push(`<span class="selectSpan">${res[k]}</span>`);
                        idArr.push(k);
                    }
                    this.el.find('#addFollowerList').html(htmlStr);
                    this.data.focusArr = idArr;
                    // Mediator.publish('workflow:focus-users', idArr);
                    this.data.user=res;
                }
            })
        },

        getWorkflowFromData() {
            let _this = this;
            let obj = this.data.obj;
            (async function () {
                return workflowService.getPrepareParams({table_id: _this.data.obj.table_id});
            })().then(res => {
                if (res.data.flow_data.length === 0) {
                    if(this.data.obj.btnType != 'new' || this.data.obj.isAddBuild==1){
                        this.el.find('.workflow-flex').hide();
                    }
                    this.el.find('.workflow-foot').hide();
                    this.el.find('#place-form').html('');
                    FormEntrys.initForm({
                        el: this.el.find('#place-form'),
                        is_view: this.data.is_view,
                        from_focus: 0,
                        table_id: obj.table_id,
                        isCalendar: this.data.isCalendar || 0,
                        //表级操作用
                        data_from_row_id: obj.data_from_row_id,
                        operation_id: obj.operation_id,
                        operation_table_id: obj.operation_table_id,
                        parent_table_id: obj.parent_table_id,
                        parent_real_id: obj.parent_real_id,
                        parent_temp_id: obj.parent_temp_id,
                        parent_record_id: obj.parent_record_id,
                        btnType: obj.btnType,
                        real_id: obj.real_id,
                        temp_id: obj.temp_id,
                        requestFormData: this.data.requestFormData||0,
                        noRequestFormData: this.data.noRequestFormData||[],
                        isAddBuild: obj.isAddBuild,
                        id: obj.id,
                        key: obj.key,
                        isFromForm:obj.isFromForm,
                        action: this.data.action,
	                    from_approve:obj.from_approve,
                        correspondence_status:obj.correspondence_status,
                    });
                    setTimeout(()=>{
                        _this.data.cache_old= CreateFormServer.getFormValue(_this.data.obj.table_id,true);
                    },1000)
                } else {
                    // Mediator.publish('workflow:getParams', res.data.flow_data);
                    _this.actions.handleParams(res['data']['flow_data']);
                }
            });
        },
        handleParams(res) {
            let _this = this;
            let htmlStr = ``;
            let obj = _this.data.obj;
            for(let i in res){
                htmlStr += `<option data-default=${res[i].selected} data-flow_id=${res[i].flow_id} data-form_id=${res[i].form_id}>${res[i].flow_name}</option>`;
            }
            this.el.find('#wf-select').html(htmlStr);
            let o={};
            if(_this.el.find('#wf-select option[data-default="1"]').length===0){
                o.flow_id=_this.el.find('#wf-select option:first').data('flow_id');
                o.form_id=_this.el.find('#wf-select option:first').data('form_id');
                this.el.find('#wf-select option:first').attr("selected",true);
                // Mediator.publish('workflow:getflows', o);
                this.actions.getFlows(o);
            }else{
                if(obj.isCustomOperate) {
                    o.flow_id=obj.flow_id;
                    o.form_id=obj.form_id;
                    this.el.find(`#wf-select option[data-flow_id=${obj.flow_id}]`).attr("selected",true);
                }else {
                    o.flow_id=_this.el.find('#wf-select option[data-default="1"]').data('flow_id');
                    o.form_id=_this.el.find('#wf-select option[data-default="1"]').data('form_id');
                    this.el.find('#wf-select option[data-default="1"]').attr("selected",true);
                }
                // Mediator.publish('workflow:getflows', o);
                this.actions.getFlows(o);
            }
            this.el.find('#wf-select').on('change',()=>{
                let o={};
                o.flow_id=this.el.find('#wf-select option:selected').data('flow_id');
                o.form_id=this.el.find('#wf-select option:selected').data('form_id');
                // Mediator.publish('workflow:getflows', o);
                this.actions.getFlows(o);
            });
        },
        getFlows(res) {
            let obj = this.data.obj;
            if (obj.btnType === 'view' && this.data.is_view !== 0) {
                this.el.find('#toEdit').show();
	            this.el.find('#addFollower').hide();
            }else if(obj.btnType==='none'){
                
	            this.el.find('#toEdit').hide();
	            this.el.find('#addFollower').hide();
            }
	        WorkFlow.saveCallBack(this.actions.getDefaultFocusUsers);
            if(obj.in_process === '1'){
                WorkFlow.createFlow({
                    flow_id: this.data.obj.flow_id,
                    el: this.el.find("#flow-node"),
                    record_id: this.data.obj.record_id,
                });
                // Mediator.publish("workflow:hideselect", this.data.obj.flow_id);
                this.actions.hideWorkflowSelect(this.data.obj.flow_id);
            }else{
                WorkFlow.createFlow({
                    flow_id: res.flow_id,
                    el: this.el.find("#flow-node"),
                    record_id:obj.record_id,
                });
                obj.flow_id = res.flow_id;
                obj.form_id = res.form_id;
            }
            this.el.find('#place-form').html('');
            FormEntrys.initForm({
                el: this.el.find('#place-form'),
                form_id: res.form_id,
                flow_id: res.flow_id,
                is_view: this.data.is_view,
                from_workflow: 1,
                from_focus: 0,
                btnType: 'none',
                table_id: obj.table_id,
                //表级操作用
                data_from_row_id: obj.data_from_row_id,
                operation_id: obj.operation_id,
                operation_table_id: obj.operation_table_id,
                parent_table_id: obj.parent_table_id,
                parent_real_id: obj.parent_real_id,
                parent_temp_id: obj.parent_temp_id,
                parent_record_id: obj.parent_record_id,
                real_id: obj.real_id,
                temp_id: obj.temp_id,
                in_process: obj.in_process,
                record_id: obj.record_id,
                isAddBuild: obj.isAddBuild,
                id: obj.id,
                key: obj.key,
                action: this.data.action,
                is_batch: obj.is_batch,
	            isAdd:obj.btnType=='new'?true:false,
                isFromForm:obj.isFromForm
            });
            setTimeout(()=>{
                this.data.cache_old = CreateFormServer.getFormValue(obj.table_id,true);
            },1000)
        },
        hideWorkflowSelect(res) {
            let sel = this.el.find('#wf-select option');
            let sellen = sel.length;
            for(let i=0;i<sellen;i++){
                if($(sel[i]).attr('data-flow_id') === res){
                    $(sel[i]).attr("selected",true);
                }
            }
            this.el.find('#wf-select').attr('disabled','disabled');
        },

        /**
         * 提交当前工作流
         */

        submitAddWorkflow() {
            if(!this.data.obj.real_id && window.top.miniFormVal){
                delete window.top.miniFormVal[this.data.obj.table_id];
            }else {
                window.top.miniFormValRealId = '';
            }
            let obj = this.data.obj;
            let formData = CreateFormServer.getFormValue(obj.table_id,true);
            let cache_data=CreateFormServer.getFormCache(obj.table_id);
            if(formData.table_id == "1586_CcrzabMYLePTkAGDqpTgo2"){ //消息推送申请流程
                // 未阅人 人数 cache_data 赋值  
                cache_data.obj_new.f17 = cache_data.obj_new?  cache_data.obj_new.f13 : '' // 未阅人
                cache_data.obj_new.f19 = JSON.parse(cache_data.obj_new.f13).length // 未阅人数
                // formData 赋值
                formData.f17 = formData.f13
                formData.f18 = 0
                formData.f19 = formData.f13.length
            }
            if (formData.error) {
                msgBox.alert(`${formData.errorMessage}`);
            } else {
                let data=_.defaultsDeep({},this.data.user);
                for(let key in this.data.focusUsers){
                    delete data[key];
                }
                let f_user = [];
                for(let k in data){
                    f_user.push(k)
                }
                let flowId;
                this.data.obj.is_batch == 1 ?flowId = '':flowId =obj.flow_id;
                formData['parent_temp_id'] = obj.parent_temp_id || '';
                CreateFormServer.childForm[obj.table_id].actions.changeValueForChildTable(formData);
                msgBox.showLoadingSelf();
                let postData = {
                    flow_id: flowId || '',
                    focus_users: JSON.stringify(f_user),
                    data: JSON.stringify(formData),
                    cache_new:JSON.stringify(cache_data.obj_new),
                    cache_old:JSON.stringify(cache_data.obj_old),
                    table_id:obj.table_id,
                    parent_table_id:obj.parent_table_id,
                    parent_real_id:obj.parent_real_id,
                    parent_temp_id:obj.parent_temp_id,
                    parent_record_id:obj.parent_record_id
                };
                if(window.config.btnType == 'new'){
                    delete postData['parent_record_id'];
                    //新增时传参作为参数使用
                    postData['isNew'] = 1;
                }
                //半触发操作用
                if( obj.data_from_row_id ){
                    postData = {
                        data: JSON.stringify(formData),
                        flow_id: obj.flow_id,
                        operation_table_id: obj.operation_table_id,
                        operation_real_id: obj.data_from_row_id,
                        focus_users: JSON.stringify(f_user),
                        cache_new:JSON.stringify(cache_data.obj_new),
                        cache_old:JSON.stringify(cache_data.obj_old),
                    }
                }
                (async function () {
                    //半触发操作用
                    if( obj.data_from_row_id ){
                        return workflowService.createWorkflowRecord(postData);
                    }else {
                        return workflowService.addUpdateTableData(postData);
                    }
                })().then(res => {
                    msgBox.hideLoadingSelf();
                    if (res.success === 1) {
                        msgBox.showTips(`保存成功`);
                        if(res.task_error_msg) msgBox.alert(res.task_error_msg);
                        Mediator.publish('calendar-save-success','');
                        obj.key && PMAPI.sendToRealParent({
                            type: PMENUM.close_dialog,
                            key: obj.key,
                            data: {
                                table_id: obj.table_id,
                                type: 'closeAddition',
                                refresh: true
                            }
                        });
                    } else {
                        msgBox.alert(`${res.error}`);
                    }
                })
            }
        },

        /**
         * 转到编辑模式
         * @param res
         */
        changeToEdit(res) {
            if(this.data.obj.is_batch !== '1') {
                $("#add-wf").find('.J_hide').removeClass('hide');
                // $("#add-wf").find('#print').removeClass('addPrint');
            }
            this.data.is_view = 0;
            CreateFormServer.changeToEdit(res);
        },
	    getDefaultFocusUsers(data){
		    workflowService.getWorkflowInfo({url: '/get_all_users/'}).then(res => {
			    this.data.htmlStr = [];
			    this.data.allUsersInfo = res.rows;
			    this.data.focusUsers={};
			    for(let key in data['updateuser2focususer']) {
				    this.data.idArr = data['updateuser2focususer'][key];
				    for(let i of this.data.idArr) {
					    this.data.nameArr.push(this.data.allUsersInfo[i]['name']);
					    this.data.focusUsers[i] = this.data.allUsersInfo[i]['name'];
					    this.data.htmlStr.push(`<span class="selectSpan">${this.data.allUsersInfo[i]['name']}</span>`);
				    }
			    }
			    this.el.find('#addFollowerList').html(this.data.htmlStr);
			    this.data.user = this.data.focusUsers;
		    })
	    }
    },
    firstAfterRender:function () {
        Mediator.subscribe('attachment:upLoading',(res)=>{
			if(res.finished === null){
				if(this.data.attachmentState.hasOwnProperty(res.file_name))
					delete this.data.attachmentState[res.file_name]
			}else{
				this.data.attachmentState[res.file_name] = res.finished
			}
		})
    },
    async afterRender(){
        PMAPI.getIframeParams(window.config.key,window.parent).then((res) => {
            this.data.noRequestFormData = res.data;
        });
        let _this=this;
        _this.showLoading();
        this.data.key = this.data.obj.key;
        await FormService.getColumnList(this.data.obj.table_id);
        // if(edit.permission.edit == 0){
        //     this.data.obj.btnType = "none"
        // }
        if (this.data.obj.btnType === 'view'||this.data.obj.btnType ==="none") {
            this.el.find('#subAddworkflow').hide();
            this.data.is_view = 1;
        }
        //判断工作流是否处于在途状态或者在批量工作流中打开forn
        if(this.data.obj.in_process === 1 || this.data.obj.is_batch === 1){
            // $("#add-wf").find('.J_hide').addClass('hide');
            this.data.action = 1;
        }
        //批量工作流隐藏多余div
        if(this.data.obj.is_batch === "1"){
            // $("#add-wf").find('#print').addClass('addPrint');
            // $("#add-wf").find('.J_hide').addClass('hide');
            // this.el.find('#print').addClass('addPrint');
            this.el.find('.J_hide').addClass('hide');
        }

        if(this.data.obj.is_view === "1" && this.data.obj.in_process === "0"){
            // $("#add-wf").find('.J_hide').addClass('hide');
            // $("#add-wf").find('#print').addClass('addPrint');
            this.el.find('.J_hide').addClass('hide');
            // this.el.find('#print').addClass('addPrint');
        }

        this.actions.getWorkflowFromData();

        Mediator.subscribe('workflow:gotWorkflowInfo', (msg)=> {
            this.data.workflowData=msg.data[0];
            WorkFlow.show(msg.data[0],'#drawflow');
        });
        // Mediator.on('getDefaultFocusUsers', (data) => {
        //     workflowService.getWorkflowInfo({url: '/get_all_users/'}).then(res => {
        //     this.data.htmlStr = [];
        //     this.data.allUsersInfo = res.rows;
        //     this.data.focusUsers={};
        //     // console.log(this.data.allUsersInfo);
        //     for(let key in data['updateuser2focususer']) {
        //         this.data.idArr = data['updateuser2focususer'][key];
        //         for(let i of this.data.idArr) {
        //             this.data.nameArr.push(this.data.allUsersInfo[i]['name']);
        //             this.data.focusUsers[i] = this.data.allUsersInfo[i]['name'];
        //             this.data.htmlStr.push(`<span class="selectSpan">${this.data.allUsersInfo[i]['name']}</span>`);
        //         }
        //     }
        //     this.el.find('#addFollowerList').html(this.data.htmlStr);
        //     this.data.user = this.data.focusUsers;
        // })
        // });
        if(this.data.obj.correspondence_status=='2'){
            this.el.find('.workflow-flex').hide();
        }
        this.el.find('#subAddworkflow').on('click',()=>{
            // Mediator.publish('workflow:submit', 1);
            for(let name in this.data.attachmentState){
				if(this.data.attachmentState[name] === false){
					msgBox.alert(name + "尚未上传完毕，请等待附件上传完毕后提交表单！");
					return
				}
			}
            this.actions.submitAddWorkflow();
        });
        this.el.on('click','#toEdit',(el)=>{
            let table_id =　location.href.split('=')[1].split('&')[0];
            // Mediator.publish('workflow:changeToEdit',table_id);
            this.actions.changeToEdit(table_id);
            $(el.target).hide();
            this.el.find("#subAddworkflow").show();
            this.el.find("#addFollower").show();
        }).on('click', '#addFollower', () => {
            this.actions.openAddFollower();
        });
    },
    beforeDestory: function () {
        Mediator.removeAll('workflow:getKey');
        Mediator.removeAll('workflow:gotWorkflowInfo');
        Mediator.removeAll('workflow:getParams');
        Mediator.removeAll('attachment:upLoading');
    }
};
let AddWorkflow = Component.extend(config)
export default AddWorkflow


// WEBPACK FOOTER //
// app/components/workflow/add-workflow/add-workflow.js